import React, { useEffect, useState } from "react";
import style from "../../PagesStyles/AdminPurchase.module.css";

import AdminHeading from "../Heading/AdminHeading";
import AdminBreadCrump from "../Heading/AdminBreadCrump";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import {
  fetchAllCategoryList,
  fetchAllProductTypes,
  fetchAllRDPurchaseList,
  fetchLotAuditReports,
  fetchVendorsList,
} from "services/invoiceServices";
import { useForm } from "react-hook-form";
import ReportTable from "Components/support/customervendor/ReportTable";
import { FaSearch } from "react-icons/fa";

const PurchaseLotAuditReport = () => {
  const navigate = useNavigate();
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  const clientCode = adminLoggedIn.ClientCode;

  const { data: allVendors } = useQuery({
    queryKey: ["getVendorsList", clientCode],
    queryFn: fetchVendorsList,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });
  const { data: allRdPurchaseItems } = useQuery({
    queryKey: ["allRdPurchaseItems", clientCode],
    queryFn: fetchAllRDPurchaseList,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });
  const { data: allCategories } = useQuery({
    queryKey: ["allCategories", clientCode],
    queryFn: fetchAllCategoryList,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });

  const { data: allProductTypes } = useQuery({
    queryKey: ["allProductTypes", clientCode],
    queryFn: fetchAllProductTypes,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });

  const { data: lotAuditReports } = useQuery({
    queryKey: ["lotAuditReports", clientCode],
    queryFn: fetchLotAuditReports,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });
  console.log(lotAuditReports);

  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      SearchQuery: "",
      AsigneeOption:"",
      Name:"",
      MaterialType:""
    },
  });
  
  const [filteredLotNumbers, setFilteredLotNumbers] = useState([]);
  const [activeList, setActiveList] = useState(1);
  const searchParam = useSearchParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const report = searchParams.get("report");
  const SearchQuery = watch("SearchQuery")
  const AsigneeOption = watch("AsigneeOption")
  const Name = watch("Name")
  const MaterialType = watch("MaterialType")
  
  console.log(SearchQuery)
  useEffect(() => {
    let rcvdData = allRdPurchaseItems?.reverse();
    let orderedData = rcvdData?.map((item, index) => {
      item.serialNumber = index + 1;
      return item;
    });
    const allLotNumbersList = orderedData?.map((x) => x.LotNumber);
    setFilteredLotNumbers(allLotNumbersList);
  }, [allRdPurchaseItems]);
  const tabs = [
    { label: "Purchase Register", link: "/purchase" },
    { label: "Lot Audit", link: "/purchaseReport?report=1" },
    { label: "Party Outstanding Report", link: "/purchaseReport?report=2" },
  ];

  const columns = [
    { key: "serialNumber", label: "Sr No", type: "read", priority: 2 },
    { key: "PurchaseDate", label: "Date", type: "read", priority: 1 },

    {
      key: "LotNumber",
      label: "Supplier / Vendor Name",
      type: "read",
      priority: 3,
    },
    { key: "PartyNumber", label: "Lot No", type: "read", priority: 5 },
    { key: "GrossWt", label: "Total Wt", type: "read", priority: 4 },
    { key: "NetWt", label: "Packing Wt", type: "read", priority: 5 },
    { key: "FPlusWPer", label: "Gross Wt", type: "read", priority: 6 },
    { key: "FPlusWWt", label: "Net Wt", type: "read", priority: 7 },
    { key: "InvoiceAmt", label: "Difference", type: "read", priority: 8 },
    { key: "TotalGSTAmount", label: "Action", type: "read", priority: 9 },
  ];


  return (
    <div>
      <AdminHeading />
      <div style={{ paddingTop: "130px" }}>
        <AdminBreadCrump
          title={"Purchase"}
          companyName={"Loyalstring"}
          module={"Trading"}
          page={"Purchase"}
        />
        <div className={style.adminAddCategoryMainBox}>
          <div className="adminAddCategoryInnerBox">
            <div
            // className={
            //   active === "List" ? "adminCategoryListMainBox" : "none"
            // }
            >
              {/* <div className={loading == true ? "loading" : "none"}>
              <div
                style={{display:"flex",alignItems:"center",justifyContent:"center"}}
                >
                    <PageLoader/>
                </div>
              </div> */}

              <div className={style.container}>
                {tabs?.map((tab, index) => (
                  <div
                    key={tab}
                    className={`${style.tab} ${
                      report == index ? style.active : ""
                    }`}
                    onClick={() => navigate(tab?.link)}
                  >
                    {tab?.label}
                  </div>
                ))}
              </div>
            </div>

            <>
              {/* ---------------------- all filter inputs starts here ------------------------- */}
              <>
                {/* <div
                    style={{
                      width: "100%",
                      justifyContent: "left",
                      flexWrap: "wrap",
                      marginTop: "30px",
                    }}
                    className="adminAllProductsFilterBox"
                  >
                   <div className={style.adminAllProductsFilterLabelBox}>
                  <input
                    className={style["input-selects2"]}
                    style={{ border: "1px solid #ddd" }}
                    type="text"
                    placeholder="Search Vendor Name / Amount / Invoice No / Inward No..."
                    // value={orderNumber2}
                    // onChange={(e) => {
                    //   setOrderNumber2(e.target.value.toLowerCase()),
                    //     setCurrentPage2(1);
                    // }}
                  />
                  <select
                    className={style["input-selects2"]}
                    // value={orderStatus2}
                    // onChange={(e) => {
                    //   setOrderStatus2(e.target.value), setCurrentPage2(1);
                    // }}
                  >
                    <option value="">Choose...</option>
                    <option value="Paid">Paid</option>
                    <option value="Partial">Partial</option>
                    <option value="None">None</option>
                  </select>
                  <select
                    className={style["input-selects2"]}
                    // value={selectedVendorId}
                    // onChange={(e) => setSelectedVendorId(e.target.value)}
                    name="selectedVendorId"
                    id="selectedVendorId"
                  >
                    <option value={0}>Select Vendor</option>

                    {allVendors?.map((x, index) => (
                      <option value={x.Id} key={index}>
                        {x?.FirmName}
                      </option>
                    ))}
                  </select>
                  <input
                    className={style["input-selects2"]}
                    // value={selectedLotNumber}
                    // onInput={(e) => setSelectedLotNumber(e.target.value)}
                    name="selectedLotNumber"
                    type="number"
                    placeholder="Enter Lot Number"
                    id="selectedLotNumber"
                    list="selectedLotNumberList"
                  />
                  <datalist id="selectedLotNumberList">
                    {filteredLotNumbers?.map((x, index) => (
                      <option value={x} key={index}>
                        {x}
                      </option>
                    ))}
                  </datalist>
                </div>
                <div className={style.adminAllProductsFilterLabelBox}>
                  <select
                    className={style["input-selects2"]}
                    // value={rdPurchaseCategory}
                    // onChange={(e) => {
                    //   setRdPurchaseCategrory(e.target.value);
                    // }}
                  >
                    <option value={""}>Select an Category</option>
                    {(allCategories || []).map((x) => (
                      <option value={x.Id}>{x.CategoryName}</option>
                    ))}
                  </select>

                  <select
                    className={style["input-selects2"]}
                    // value={rdPurchaseProduct}
                    // onChange={(e) => {
                    //   setRdPurchaseProduct(e.target.value);
                    // }}
                  >
                    <option value={""}>Select an Product</option>
                    {allProductTypes?.map((x) => (
                      <option value={x.Id}>{x.ProductName}</option>
                    ))}
                  </select>

                  <input
                    className={style["input-selects2"]}
                    type="date"
                    placeholder="From Date"
                    // value={fromDate2}
                    // onChange={(e) => setFromDate2(e.target.value)}
                  />
                  <input
                    className={style["input-selects2"]}
                    type="date"
                    placeholder="To Date"
                    // value={toDate2}
                    // onChange={(e) => setToDate2(e.target.value)}
                  />
                </div>

                <div className={style.adminAllProductsFilterLabelBox}>
                  <input
                    className={style["input-selects2"]}
                    style={{ border: "1px solid #ddd" }}
                    type="text"
                    placeholder="Total Fine Gold (F+W)"
                    // value={`Total Fine Gold (F+W) = ${filteredOrders2
                    //   .reduce(
                    //     (a, b) =>
                    //       a +
                    //       (b.TotalFineGold ? parseFloat(b.TotalFineGold) : 0),
                    //     0
                    //   )
                    //   .toFixed(3)}`}
                  />
                  <input
                    style={{ border: "1px solid #ddd" }}
                    className={style["input-selects2"]}
                    type="text"
                    placeholder="Total Fine Silver (F+W)"
                    // value={`Total Fine Silver (F+W) = ${filteredOrders2
                    //   .reduce(
                    //     (a, b) =>
                    //       a +
                    //       (b.TotalFineSilver
                    //         ? parseFloat(b.TotalFineSilver)
                    //         : 0),
                    //     0
                    //   )
                    //   .toFixed(3)}`}
                  />
                  <input
                    style={{ border: "1px solid #ddd" }}
                    className={style["input-selects2"]}
                    type="text"
                    placeholder="Total Gold (Gross Wt)"
                    // value={`Total Gold (Gross Wt)= ${filteredRdPurchaseItems
                    //   .filter((item) =>
                    //     item.CategoryName.toLowerCase().includes("gold")
                    //   )
                    //   .reduce(
                    //     (a, b) => a + (b.GrossWt ? parseFloat(b.GrossWt) : 0),
                    //     0
                    //   )
                    //   .toFixed(3)}`}
                  />
                  <input
                    style={{ border: "1px solid #ddd" }}
                    className={style["input-selects2"]}
                    type="text"
                    placeholder="Total Silver (Gross Wt)"
                    // value={`Total Silver (Gross Wt)= ${filteredRdPurchaseItems
                    //   .filter((item) =>
                    //     item.CategoryName.toLowerCase().includes("silver")
                    //   )
                    //   .reduce(
                    //     (a, b) => a + (b.GrossWt ? parseFloat(b.GrossWt) : 0),
                    //     0
                    //   )
                    //   .toFixed(3)}`}
                  />
                </div>

                <div className={style.adminAllProductsFilterLabelBox}>
                  <input
                    style={{ border: "1px solid #ddd" }}
                    className={style["input-selects2"]}
                    type="text"
                    placeholder="Total Gold (Net Wt)"
                    // value={`Total Gold (Net Wt)= ${filteredRdPurchaseItems
                    //   .filter((item) =>
                    //     item.CategoryName.toLowerCase().includes("gold")
                    //   )
                    //   .reduce(
                    //     (a, b) => a + (b.NetWt ? parseFloat(b.NetWt) : 0),
                    //     0
                    //   )
                    //   .toFixed(3)}`}
                  />
                  <input
                    style={{ border: "1px solid #ddd" }}
                    className={style["input-selects2"]}
                    type="text"
                    placeholder="Total Silver (Net Wt)"
                    // value={`Total Silver (Net Wt)= ${filteredRdPurchaseItems
                    //   .filter((item) =>
                    //     item.CategoryName.toLowerCase().includes("silver")
                    //   )
                    //   .reduce(
                    //     (a, b) => a + (b.NetWt ? parseFloat(b.NetWt) : 0),
                    //     0
                    //   )
                    //   .toFixed(3)}`}
                  />
                  <input
                    style={{ border: "1px solid #ddd" }}
                    className={style["input-selects2"]}
                    type="text"
                    placeholder="Total Purchase Amount"
                    // value={`Total Purchase Amount = ${filteredOrders2
                    //   .reduce(
                    //     (a, b) =>
                    //       a +
                    //       (b.TotalPurchaseAmount
                    //         ? parseFloat(b.TotalPurchaseAmount)
                    //         : 0),
                    //     0
                    //   )
                    //   .toFixed(2)
                    //   .toString()
                    //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}
                    readOnly
                  />
                  <input
                    style={{ border: "1px solid #ddd" }}
                    className={style["input-selects2"]}
                    type="text"
                    placeholder="Total Balance Amount"
                    // value={`Total Balance Amount = ${filteredOrders2
                    //   .reduce(
                    //     (a, b) =>
                    //       a +
                    //       (b.BalanceAmount ? parseFloat(b.BalanceAmount) : 0),
                    //     0
                    //   )
                    //   .toFixed(2)
                    //   .toString()
                    //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}
                    readOnly
                  />
                </div>

                <div
                  style={{ marginTop: "20px", marginBottom: "20px" }}
                  className="adminAllLabelledListButtonBox"
                >
                  <button
                    style={{ backgroundColor: "#0077d4", color: "#fff" }}
                    // onClick={() => printAllRDPurchase(filteredRdPurchaseItems)}
                  >
                    <Icon
                      icon="material-symbols:print-outline-rounded"
                      width="24"
                      height="24"
                    />
                    Print
                  </button>
                </div>
                  </div> */}
              </>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px 10px 8px 10px",
                }}
              >
                <div style={{ display: "flex", gap: "4px" }}>
                  <select 
                   {...register("AsigneeOption")}
                  style={{ background: "#D3D3D3" }}>
                    <option>Party or Karigar</option>
                    <option>1</option>
                  </select>

                  <select 
                  {...register("Name")}
                  style={{ background: "#D3D3D3" }}>
                    <option>Select Name</option>
                    <option>1</option>
                  </select>
                  <select 
                   {...register("MaterialType")}
                  style={{ background: "#D3D3D3" }}>
                    <option>Material Type</option>
                    <option>1</option>
                  </select>
                </div>
                <div
                  style={{
                    borderRadius: "50px",
                    padding: "2px 10px",
                    border: "1px solid gray",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <FaSearch />
                  <input
                    {...register("SearchQuery")}
                    placeholder="Search"
                    style={{
                      background: "#fff",
                      outline: "none",
                      border: "none",
                      boxShadow: "none",
                    }}
                  />
                </div>
              </div>
              {report != 2 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    onClick={() => setActiveList(1)}
                    style={{
                      flex: "1",
                      cursor: "pointer",
                      background: `${activeList == 1 ? "#627383" : "#D3D3D3"}`,
                      color: `${activeList == 1 ? "#fff" : ""}`,
                      padding: "10px",
                    }}
                  >
                    Pending List
                  </div>
                  <div
                    onClick={() => setActiveList(2)}
                    style={{
                      flex: "1",
                      cursor: "pointer",
                      background: `${activeList == 2 ? "#627383" : "#D3D3D3"}`,
                      color: `${activeList == 2 ? "#fff" : ""}`,
                      padding: "10px",
                    }}
                  >
                    Approved List
                  </div>
                </div>
              )}
              {/* ---------------------- all filter inputs end here ------------------------- */}
            </>
            {/* ------------------------table starts here------------------ */}

            <ReportTable
              columns={columns}
              allCategories={[]}
              searchInput={""}
              setSearchInput={() => {}}
            />
            {/* ------------------------table ends here------------------ */}
            <div
              style={{ margin: 0 }}
              // className={
              //   active !== "List" ? "adminCategoryListMainBox" : "none"
              // }
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseLotAuditReport;
